import React, { useEffect, useState } from "react";
import { Paper, InputBase, IconButton, Box, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchBar from "components/commonSearch/SearchBar";
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import CommonFilter from "components/commonFilter/CommonFilter";

export default function CommonSDF(props) {
    console.log("props in common sdf", props);  
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'flex-end',
                    justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
                    width: '100%',
                    gap: 2
                }}
            >
               
                <Box  sx={{ width: props?.tabName === "complaints" ? '280px' : 'auto' }}>
                    <SearchBar
                        {...props}
                        onSearchQuery={props?.onSearchQuery}
                        placeholder={
              props?.tabName === "complaints" 
              ? "Search by Ticket Id" 
              : "Search"}
            fullWidth
                    />
               </Box>
            
                {(props.tabName !== "company" && props.tabName !== "complaints") && (
                <Box sx={{ width: '280px',marginRight:'20px' }}>
                    <CommonDateRangePicker
                        {...props}
                        allowFutureDates={true}
                    />
                </Box>
                 )}
                {(props.filter || props.tabName === "complaints") &&  (
                <Box sx={{ width: 'auto' }}>
                    <CommonFilter
                        {...props}
                    />
                </Box>
                )}
            </Box>
        </>
    )
}
